"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateReceivePromos = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var useUpdateReceivePromos = function () {
    var _a = (0, useMutation_1.useMutation)({
        keysUpdate: [keys_1.USER],
        path: keys_1.UPDATE_RECEIVE_PROMOS,
    }), mutate = _a.mutate, isSubmitting = _a.isSubmitting, error = _a.error;
    return (0, react_1.useMemo)(function () { return ({
        updateReceivePromos: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useUpdateReceivePromos = useUpdateReceivePromos;
